/* eslint-disable new-cap */
/* eslint-disable no-underscore-dangle */
const {
  loadingPanelProps: {
    loadingPanelSelector,
    localizedMessages,
    globalNumberFormat,
  },
} = window._webpack_init_props;
delete window._webpack_init_props.loadingPanelProps;

window.loadingPanel = new window.blocker(window.$(loadingPanelSelector));
window.localizedMessages = localizedMessages;
window.globalNumberFormat = globalNumberFormat;
